import { Injectable } from '@angular/core';
import { LoggerService } from '@services/logger.service';
import jwtDecode, { JwtPayload } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class JwtHelperService {
  isTokenExpired(token: string) {
    // Check for null, undefined, or empty token
    // This is a normal case (e.g., during logout), so we don't log it as an error
    if (!token || token.length === 0) {
      return true;
    }

    LoggerService.log('Decoding JWT token');

    try {
      const jwtDecoded = jwtDecode<JwtPayload>(token); // Returns with the JwtPayload type

      // Check if token has expiration
      if (!jwtDecoded.exp) {
        LoggerService.error('JWT token has no expiration!');

        return true;
      }

      if (Date.now() >= jwtDecoded.exp * 1000) {
        LoggerService.error('JWT token expired!');

        return true;
      }

      return false;
    } catch (error) {
      LoggerService.error('JWT token decode error:', error);

      return true; // If decode fails, consider token expired/invalid
    }
  }

  getToken(): string {
    return localStorage.getItem('cassa.jwttoken') ?? '';
  }
}
